module.exports = __webpack_public_path__ + "static/img/home-decor-1.decbdadf.jpg";